export const GET_CONTRACT_TEMPLATE_LIST = "GET_CONTRACT_TEMPLATE_LIST";
export const GET_CONTRACT_TEMPLATE_LIST_ORGANISATION_ID = "GET_CONTRACT_TEMPLATE_LIST_ORGANISATION_ID"
export const SET_CONTRACT_TEMPLATE_LIST = "SET_CONTRACT_TEMPLATE_LIST";

export const GET_CONTRACT_TEMPLATE_BY_ID = "GET_CONTRACT_TEMPLATE_BY_ID";
export const SET_CONTRACT_TEMPLATE_BY_ID = "SET_CONTRACT_TEMPLATE_BY_ID";

export const ADD_CONTRACT_TEMPLATE = "ADD_CONTRACT_TEMPLATE";
export const ADD_CONTRACT_TEMPLATE_RESPONSE = "ADD_CONTRACT_TEMPLATE_RESPONSE";

export const UPDATE_CONTRACT_TEMPLATE = "UPDATE_CONTRACT_TEMPLATE";
export const UPDATE_CONTRACT_TEMPLATE_RESPONSE = "UPDATE_CONTRACT_TEMPLATE_RESPONSE";

export const DELETE_CONTRACT_TEMPLATE = "DELETE_CONTRACT_TEMPLATE";
export const DELETE_CONTRACT_TEMPLATE_RESPONSE = "DELETE_CONTRACT_TEMPLATE_RESPONSE";

